import React, { useRef, useEffect, useState } from "react";
import { DropdownListItem } from "./DropdownListItem.component";
import { KEY, DIRECTION } from "components/common/constants";
import { IDropdownList } from "types/gaiaComponents/dropdownButton";
import { DropdownPosition } from "types/gaiaComponents/dropdownButton.types";

export const DropdownList = (props: IDropdownList) => {
    const [focusedIndex, setFocusedIndex] = useState(0);
    const itemRefs = useRef<(HTMLButtonElement | null)[]>([]);

    // Find the first non-disabled item index
    const findNextEnabledIndex = (startIndex: number, direction: string): number => {
        const increment = direction === DIRECTION.DOWN ? 1 : -1;
        let newIndex = startIndex + increment;

        while (newIndex >= 0 && newIndex < props.items.length) {
            if (!props.items[newIndex].disabled) {
                return newIndex;
            }
            newIndex += increment;
        }

        // If no enabled item found, return the current index
        return startIndex;
    };

    // Set initial focus to first non-disabled item
    useEffect(() => {
        const firstEnabledIndex = props.items.findIndex(item => !item.disabled);
        if (firstEnabledIndex !== -1 && firstEnabledIndex !== focusedIndex) {
            setFocusedIndex(firstEnabledIndex);
        }
    }, [props.items]);

    useEffect(() => {
        if (props.autoFocus === false) return;
        if (itemRefs.current[focusedIndex]) {
            itemRefs.current[focusedIndex]?.focus();
        }
    }, [focusedIndex, props.items, props.autoFocus]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === KEY.ARROW_DOWN) {
            e.preventDefault();
            const nextIndex = findNextEnabledIndex(focusedIndex, DIRECTION.DOWN);
            if (nextIndex !== focusedIndex) {
                setFocusedIndex(nextIndex);
                itemRefs.current[nextIndex]?.focus();
            }
        } else if (e.key === KEY.ARROW_UP) {
            e.preventDefault();
            const nextIndex = findNextEnabledIndex(focusedIndex, DIRECTION.UP);
            if (nextIndex !== focusedIndex) {
                setFocusedIndex(nextIndex);
                itemRefs.current[nextIndex]?.focus();
            }
        } else if (e.key === KEY.ENTER) {
            e.preventDefault();
            const focusedItem = props.items[focusedIndex];
            if (focusedItem && !focusedItem.disabled && focusedItem.onClick) {
                focusedItem.onClick();
            }
        }
    };

    return (
        <div role="listbox"
             className={`ga-dropdown ${props.class} ${props.position === DropdownPosition.TOP_LEFT || props.position === DropdownPosition.TOP_RIGHT ? "v-align-top": ""}  ${props.position === DropdownPosition.BOTTOM_LEFT || props.position === DropdownPosition.TOP_LEFT ? "h-align-left": ""}`}
             tabIndex={0}
             onKeyDown={handleKeyDown}>
            {props.items.map((item, idx) => (
                <DropdownListItem
                    {...item}
                    ref={el => itemRefs.current[idx] = el}
                    tabIndex={focusedIndex === idx ? 0 : -1}
                    key={item.key}
                />
            ))}
        </div>
    );
}